export const HomePageURL = "/dashboard/sales";